import React from 'react';
import Svg, { Path, Circle } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const Chat: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 60)} fill="none">
            <Path
                d="M25.721 39.496c0 2.395 1.932 4.336 4.315 4.336h10.19l5.9 7.041c.569.679 1.663.421 1.873-.44l1.606-6.6h3.08c2.383 0 4.315-1.942 4.315-4.337V24.317c0-2.395-1.931-4.336-4.314-4.336h-7.85"
                stroke={props.color}
            />
            <Path
                d="M10.95 8.246A6.95 6.95 0 004 15.197V30.53a6.951 6.951 0 006.449 6.933l1.792 7.325c.338 1.381 2.1 1.794 3.017.707l6.75-8.014h13.577a6.95 6.95 0 006.951-6.951V15.197a6.95 6.95 0 00-6.95-6.95H10.95z"
                fill="#fff"
                stroke={props.color}
                strokeWidth={2}
            />
            <Circle cx={14.9825} cy={22.0989} r={1.79375} fill="#fff" stroke={props.color} />
            <Circle cx={23.671} cy={22.0989} r={1.79375} fill="#fff" stroke={props.color} />
            <Circle cx={32.3595} cy={22.0989} r={1.79375} fill="#fff" stroke={props.color} />
        </Svg>
    );
};

export default React.memo(Chat);
